import Vue from 'vue'
import { eventos as routing } from '@/util/routes'

export default {
  state: {
    eventos: [],
    evento: {}
  },
  mutations: {
    setEventos: (state, payload) => {
      state.eventos = payload
    },
    setEvento: (state, payload) => {
      state.evento = payload
    }
  },
  actions: {
    async getEventos ({ commit }, { industria, periodo }) {
      commit('setEventos', [])
      const { data } = await Vue.axios.get(`${routing}`, {
        params: {
          periodo,
          industria
        }
      })
      commit('setEventos', data)
    },
    async getEvento ({ commit }, { id }) {
      commit('setEvento', {})
      const { data } = await Vue.axios.get(`${routing}/${id}`)
      commit('setEvento', data)
    },
    async postSaveEventos ({ state, getters }, { periodo }) {
      const { industria } = getters
      return Vue.axios.post(`${routing}`, { periodo, industria: industria.id })
    },
    async putSaveEvento ({ state }) {
      const { evento } = state
      return Vue.axios.put(`${routing}/${evento.id}`, evento)
    }
  },
  getters: {
    eventos: ({ eventos }) => eventos,
    evento: ({ evento }) => evento
  }
}
